import Transport from '../../common/services/api/Transport';

const transport = new Transport();

export const getComments = async (parentTitle, parentId) => {
    try {
        const result = await transport.get({ path: `${parentTitle}/${parentId}/comments` });
        return result.data.statusCode === 200 ? result.data.data.comments : [];
    } catch (error) {
        return null;
    }
};

export const createComment = async (parent, parentId, commentData) => {
    try {
        const result = await transport.post({
            path: `${parent}/${parentId}/comments`,
            data: commentData,
        });
        return result.data.statusCode === 200 ? result.data.data : {};
    } catch (error) {
        return null;
    }
};

export const updateComment = async (parentTitle, parentId, commentId, commentData) => {
    try {
        const result = await transport.put({
            path: `${parentTitle}/${parentId}/comments/${commentId}`,
            data: commentData,
        });
        return result.data.statusCode === 200 ? result.data.data : {};
    } catch (error) {
        return null;
    }
};

export const deleteComment = async (parentTitle, parentId, commentId) => {
    try {
        const result = await transport.delete({ path: `${parentTitle}/${parentId}/comments/${commentId}` });
        return result.data.statusCode === 200 ? result.data.data : {};
    } catch (error) {
        return null;
    }
};
